import {
  TypedUseSelectorHook,
  useSelector as useSelectorWithoutTypes,
} from 'react-redux';
import { RootState } from '~/store';

export const useSelector: TypedUseSelectorHook<RootState> =
  useSelectorWithoutTypes;
